export default {
  id: 'teams_promote_content',
  title: 'Promote content',
  type: 'Direct',
  relations: [ 'CONTENT' ],
  description: 'Send a selected piece of content to your employees so they can easily share it across their network.',
  body: `<div>
    <p>[[INPUT_INTRODUCTION_TEXT]]</p>
    <h2 style="margin: 0px"><strong style='font-weight: bold;'>{{CONTENT_TITLE}}</strong></h2>
    <div style='display: inline-block; margin: 0px'>
      <a style='display: inline-block; color:#333' href='{{CONTENT_LINKEDIN_SHARE_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>LinkedIn</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{CONTENT_FACEBOOK_SHARE_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Facebook</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{CONTENT_WHATSAPP_SHARE_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>WhatsApp</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{CONTENT_TWITTER_SHARE_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Twitter</pre>
      </a>
      <a style='display: inline-block; color:#333' href='{{CONTENT_MESSENGER_SHARE_LINK}}'>
        <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Messenger</pre>
      </a>
    </div>
    <div>
      <h3>Unsure what to send? How About:</h3>
      <blockquote>[[INPUT_CONTENT_SHARE_TEXT]]</br><a href='{{CONTENT_SHARE_LINK}}'>{{CONTENT_SHARE_LINK}}</a></blockquote>
    </div>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Share the following content with your network to win rewards! ...',
      defaultValue: 'Share the following content with your network to win rewards!',
      type: 'HTML'
    },
    INPUT_CONTENT_SHARE_TEXT: {
      label: 'Share Text',
      placeholder: 'Checkout the following page...',
      defaultValue: 'Checkout the following page {{CONTENT_TITLE}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/promoteContent.js